module.exports = require("mocha");


//////////////////
// WEBPACK FOOTER
// external "mocha"
// module id = 2806
// module chunks = 0 1